import React from 'react';
import PropTypes from 'prop-types';
import ExpandableSection from '../../expandableSection';
import { ActionButtons, DateCell } from './sectionShared';

const ProgressSection = ({
  expanded,
  onToggle,
  onDownload,
  onMoreMenuItems,
  onMore,
  showMoreAction,
  showActions,
  canEditProgress,
  canDeleteProgress,
  getProgressSortClass,
  progressSort,
  getAriaSort,
  handleProgressSort,
  progressSortedData,
  handleProgressEdit,
  handleProgressDelete,
  isLoading,
}) => (
  <ExpandableSection
    title="Progress %"
    sectionId="project-details-section-progress"
    expanded={expanded}
    onToggle={onToggle}
    onDownload={onDownload}
    onMoreMenuItems={onMoreMenuItems}
    onMore={onMore}
    showMoreAction={showMoreAction}
    isLoading={isLoading}
  >
    <div className="section-content progress-section">
      <div className="progress-table-wrapper">
        <div className="progress-table-scroll">
          <table className="progress-data-table">
            <thead>
              <tr>
                <th
                  className={`th-cell sortable ${getProgressSortClass('date')}`}
                  aria-sort={getAriaSort(progressSort.key, 'date', progressSort.direction)}
                >
                  <button type="button" className="th-content" onClick={() => handleProgressSort('date')}>
                    <span>Date</span>
                    <span className="sort-icon" />
                  </button>
                </th>
                <th
                  className={`th-cell sortable ${getProgressSortClass('progress')}`}
                  aria-sort={getAriaSort(progressSort.key, 'progress', progressSort.direction)}
                >
                  <button type="button" className="th-content" onClick={() => handleProgressSort('progress')}>
                    <span>Progress %</span>
                    <span className="sort-icon" />
                  </button>
                </th>
                <th
                  className={`th-cell sortable ${getProgressSortClass('remarks')}`}
                  aria-sort={getAriaSort(progressSort.key, 'remarks', progressSort.direction)}
                >
                  <button type="button" className="th-content" onClick={() => handleProgressSort('remarks')}>
                    <span>Comments</span>
                    <span className="sort-icon" />
                  </button>
                </th>
                {showActions ? (
                  <th className="th-cell th-actions">
                    <div className="th-content th-actions-content">
                      <span>Actions</span>
                    </div>
                  </th>
                ) : null}
              </tr>
            </thead>
            <tbody>
              {progressSortedData.map((row, idx) => (
                <tr key={row.id || idx} className="tr-data">
                  <td className="td-cell">
                    <DateCell date={row.date} day={row.day} />
                  </td>
                  <td className="td-cell td-progress-value">{Number(row.progress || 0).toFixed(2)}%</td>
                  <td className="td-cell td-remarks" data-remarks={row.remarks || ''}>
                    <span className="remarks-text">{row.remarks || ''}</span>
                    <span className="remarks-tooltip">{row.remarks || ''}</span>
                  </td>
                  {showActions ? (
                    <td className="td-cell td-actions">
                      <ActionButtons
                        onEdit={canEditProgress ? () => handleProgressEdit(row) : null}
                        onDelete={canDeleteProgress ? () => handleProgressDelete(row) : null}
                      />
                    </td>
                  ) : null}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </ExpandableSection>
);

ProgressSection.propTypes = {
  expanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  onDownload: PropTypes.func,
  onMoreMenuItems: PropTypes.array,
  onMore: PropTypes.func,
  showMoreAction: PropTypes.bool,
  showActions: PropTypes.bool,
  canEditProgress: PropTypes.bool,
  canDeleteProgress: PropTypes.bool,
  getProgressSortClass: PropTypes.func.isRequired,
  progressSort: PropTypes.shape({
    key: PropTypes.string,
    direction: PropTypes.string,
  }).isRequired,
  getAriaSort: PropTypes.func.isRequired,
  handleProgressSort: PropTypes.func.isRequired,
  progressSortedData: PropTypes.array.isRequired,
  handleProgressEdit: PropTypes.func.isRequired,
  handleProgressDelete: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

ProgressSection.defaultProps = {
  onDownload: null,
  onMoreMenuItems: [],
  onMore: null,
  showMoreAction: true,
  showActions: true,
  canEditProgress: true,
  canDeleteProgress: true,
  isLoading: false,
};

export default ProgressSection;
